export default __webpack_public_path__ + "locales/si/ChangeUserStatusDialog.json?hash=9cd8da0bb48d8ee806885e56d205a5e5";